import Model, { attr } from '@warp-drive/legacy/model';
import type { Type } from '@warp-drive/core/types/symbols';
import { fragment } from 'ember-data-model-fragments/attributes';
import type GradescheduleNumeric from '@linc-technologies/linced-common/models/assessments/gradeschedule-numeric';
import type GradescheduleSelect from '@linc-technologies/linced-common/models/assessments/gradeschedule-select';

// Proto: assessments.GradeScheduleTemplate.
export default class GradeSchedule extends Model {
  declare [Type]: 'assessments/grade-schedule';

  @attr('number')
  declare updateTime: number | undefined;

  @attr('number')
  declare createTime: number | undefined;

  @attr('boolean', { defaultValue: false })
  declare isPublished: boolean;

  @attr('boolean', { defaultValue: false })
  declare isLocked: boolean;

  @attr('boolean', { defaultValue: false })
  declare isCustom: boolean;

  @attr('boolean', { defaultValue: false })
  declare isShared: boolean;

  @attr('string', { defaultValue: '' })
  declare label: string;

  @attr('string', { defaultValue: '' })
  declare description: string;

  @attr('number', { defaultValue: 0 })
  declare awardMethod: number;

  @fragment('assessments/gradeschedule-select')
  declare select: GradescheduleSelect | null;

  @fragment('assessments/gradeschedule-numeric')
  declare numeric: GradescheduleNumeric | null;
}
